import { AgentRequest } from '~/protos/agents'
import { getDeviceId } from '~/utils/storage'

export async function submitCampaignTask(request: AgentRequest) {
  const response = await fetch('/api/campaign/task-submit', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/octet-stream',
      'X-DEVICE-ID': request.deviceId
    },
    body: AgentRequest.encode(request).finish()
  })

  if (!response.ok) {
    const { detail: reason } = await response.json()
    throw new Error(reason)
  }

  return response.json() as unknown as { taskId: number }
}

export async function isEmailSet(): Promise<boolean> {
  const uid = getDeviceId()
  const response = await fetch('/api/campaign/user', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ uid })
  })

  if (!response.ok) {
    const { detail: reason } = await response.json()
    throw new Error(reason)
  }
  const { is_email_set } = (await response.json()) as unknown as { is_email_set: boolean }
  return is_email_set
}

export interface UploadFileOptions {
  onProgress?: (progress: number) => void
  onComplete?: (path: string) => void
  onError?: (error: string) => void
}

export async function uploadFile(file: File, options: UploadFileOptions) {
  const { onProgress = () => {}, onComplete = (path: string) => {}, onError = () => {} } = options
  const formData = new FormData()
  formData.append('file', file)

  try {
    const response = await fetch('/api/campaign/upload', {
      method: 'PUT',
      body: formData
    })

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    const reader = response.body?.getReader()
    if (!reader) {
      throw new Error('Response body is not readable')
    }

    while (true) {
      const { done, value } = await reader.read()
      if (done) break

      const chunk = new TextDecoder().decode(value)
      const lines = chunk.split('\n').filter(line => line.trim() !== '')

      for (const line of lines) {
        const data = JSON.parse(line)
        if (data.error) {
          onError(data.error)
          return
        }
        if (data.progress) {
          onProgress(data.progress)
        }
        if (data.status === 'completed') {
          onComplete(data.path)
          return
        }
      }
    }
  } catch (error) {
    onError(error instanceof Error ? error.message : 'An unknown error occurred')
  }
}
